import React from "react";
import { UsersIcon } from "lucide-react";
interface ScarcityBarProps {
  className?: string;
}
export function ScarcityBar({
  className = ""
}: ScarcityBarProps) {
  const spotsLeft = 9;
  const percent = 91; // bar appears almost full

  return <div className={`w-full rounded-xl border border-red-500/30 bg-red-500/10 p-4 ${className}`} data-id="element-158" data-mp="2l2tqwhrutjo4">
      <div className="flex items-center justify-between gap-2" data-id="element-159" data-mp="2q1o7re69gy5l">
        <span className="flex items-center gap-1.5 text-sm font-bold text-red-300" data-id="element-160" data-mp="2b5yvi7qvnze2">
          <UsersIcon className="h-4 w-4" data-id="element-161" data-mp="2g6w9070y0598" />
          Cupos al precio promocional
        </span>
        <span className="scarcity-pulse text-sm font-extrabold text-red-400" data-id="element-162" data-mp="226tsao4dfhvk">
          ¡Solo {spotsLeft} disponibles!
        </span>
      </div>
      <div className="mt-2.5 h-3 w-full overflow-hidden rounded-full bg-neutral-800" data-id="element-163" data-mp="27798dng1f3h8">
        <div className="h-full rounded-full bg-red-500 scarcity-pulse" style={{
        width: `${percent}%`
      }} data-id="element-164" data-mp="fgraa5ixu4s" />
      </div>
      <p className="mt-2 text-xs text-white/60" data-id="element-165" data-mp="33mmrqlb31trd">
        Cuando se agoten los cupos, el precio vuelve a su valor normal.
      </p>
    </div>;
}